// extracted by mini-css-extract-plugin
export default {"key-id":"_8uYSfHe4DT","keyId":"_8uYSfHe4DT","right-tag-group":"_39qEGuFcvz","rightTagGroup":"_39qEGuFcvz","right-tag":"_2DbTljJMaN","rightTag":"_2DbTljJMaN","none":"hht7S9dsly"};
    if(module.hot) {
      // 1623933112626
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  